// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3tmck","home__bgimg":"Home_home__bgimg__m0ux0","home__row":"Home_home__row__2rgGr"};